<template>
    <el-drawer
        title="新建群组"
        :visible.sync="drawerShow"
        :wrapperClosable="false"
        :destroy-on-close="true"
        :size="400"
        @close="close"
    >
        <div class="drawer-content" v-loading="dataLoading">
            <el-form
                :model="formData"
                :rules="rules"
                ref="formData"
                label-position="top"
                size="medium"
            >
                <el-form-item prop="activityId" label="群演出ID:">
                    <el-select
                        v-model="formData.activityId"                       
                        filterable
                        remote
                        placeholder="请输入已上线的演出ID"
                        :remote-method="searchActivity"
                        :loading="searchLoading"						
                        value-key="id">
                        <el-option
							 v-for="item in activityList"
                            :key="item.id"
                            :label="`${item.id}`"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item prop="name" label="群组名称:">
                    <!-- <el-input v-model="formData.name" placeholder="演出短标题" autosize type="text" :readonly="true" disabled></el-input> -->
					<div>{{formData.name}}</div>
                </el-form-item>
                <el-form-item prop="owner" label="指定群主ID:">
                    <el-select
                        v-model="formData.owner"
                        filterable
                        remote
                        placeholder="请选择群主"
                        :remote-method="searchMainUser"
                        :loading="userLoading"
                        value-key="id">
                        <el-option
                            v-for="item in mainUserList"
                            :key="item.id"
                            :label="`${item.name}(${item.id})`"
                            :value="item">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item prop="adminList" label="群管理:">
					<span slot="label">指定群管理：<el-checkbox v-model="formData.isAddHost" :true-label="1" :false-label="0">自动将演出主办设置为群管理</el-checkbox></span>
                    <el-select
                        v-model="formData.adminList"
                        multiple
                        filterable
                        remote
                        placeholder="请选择群组管理"
                        :remote-method="searchAdminUser"
                        :loading="userLoading"
                        value-key="id">
                        <el-option
                            v-for="item in adminUserList"
                            :key="item.id"
                            :label="`${item.name}(${item.id})`"
                            :value="item">
                        </el-option>
                    </el-select>
                </el-form-item>				
				<el-form-item  label="群解散时间:">
					<div v-if="formData.disbandmentTimeType == 0 ">演出结束后48小时自动解散</div>
					<div v-else-if="formData.disbandmentTimeType == 1 ">演出结束后7天自动解散</div>
					<div v-else-if="formData.disbandmentTimeType == 2 ">演出结束后30天自动解散</div>
				</el-form-item>
            </el-form>
        </div>
        <div class="drawer-footer">
            <el-button @click="close">取消</el-button>
            <el-button type="primary" @click="submitForm()" :loading="btnLoading"
                >确认</el-button
            >
        </div>
    </el-drawer>
</template>
<script>
import {fetchUser} from '@/assets/js/commonApi';
const defaultData = {
    activityId:"",
	adminList:[],
	isAddHost: 0,
    name: "演出短标题",
    owner:null,
	disbandmentTimeType:0
}
export default {
    
    data(){
        return{
            drawerShow: false,
            btnLoading: false,
            dataLoading: false,
            formData:{
                ...defaultData
            },
            
            rules:{
				activityId:[{ required: true, message: "请填写演出ID" }],
                name:[{ required: true, message: "请填写名称" }],
                owner: [{required: true, message: "请选择群主"}]
            },

            userLoading: false,
            mainUserList: [],
            adminUserList:[],
			
			searchLoading:false,
			activityList: [],
			
        }
		
    },
    methods:{
        close(){
            this.$refs.formData.resetFields();
            this.drawerShow = false;
            this.formData = {
                ...defaultData
            }
            this.mainUserList = [];
            this.adminUserList = [];
			this.activityList = [];
			
        },
        show(type){            
            this.drawerShow = true;
			this.formData.disbandmentTimeType = type
			
        },		
        submitForm(){
            this.$refs["formData"].validate((valid) => {
                if (valid) {
                    this.btnLoading = true;    
                    this.$request({
                        url: '/group/create',
                        data: {...this.formData},
                        method: "post",
                    })
                        .then((res) => {
                            const { state, msg } = res.data;
                            if (state == 1) {
                                this.$emit('onUpdate');
                                this.close();
                            } else {
                                this.$message.error(msg || "操作失败,请重试");
                            }
                        })
                        .catch(() => {
                            this.$message.error("操作失败,请重试");
                        })
                        .finally(() => {
                            this.btnLoading = false;
                        });   
                } else {
                    return false;
                }
            });
        },
		
		async searchActivity(query){
			this.searchLoading = true
			this.$request({
			    url: '/group/searchActivity',
			    params: {id:query},
			    method: "post",
			})
			    .then((res) => {
			        const { state, msg ,result} = res.data;
			        if (state == 1) {			           
						var arr = result
						if( arr ){
							this.activityList.push({
								id: arr.id,
								title: arr.title
							})
							this.formData.name = arr.title
							this.searchLoading = false
						}else{
							this.activityList = []
							this.searchLoading = false
						}
						
			        } else {
			            this.$message.error(msg || "操作失败,请重试");
						this.searchLoading = false
			        }
			    })
			    .catch(() => {
			        this.$message.error("操作失败,请重试");
			    })
			    .finally(() => {
			        this.btnLoading = false;
			    }); 
		},
        async searchMainUser(query){
            this.searchUser(query,'mainUserList');
        },
        async searchAdminUser(query){
            this.searchUser(query,'adminUserList');
        },
        // 查找用户
        async searchUser(query,type){
            if(query !== ""){
                this.userLoading = true;
                const res = await fetchUser({
                    queryValue:query,
                    userType: 0
                }).finally(() => {
                    this.userLoading = false;
                });
                
                const { state, result } = res.data;
                
                if (state == 1 && result) {
                    if( type == 'mainUserList' ){
                        this.mainUserList = result
                    }
                    if( type == 'adminUserList' ){
                        this.adminUserList = result
                    }
                }
            }
        },
    }
}
</script>

<style lang="scss" scoped>

</style>